import { isBrandSymbol as _isBrandSymbol } from '../../../theme/icons/utils';

/*
 RULES:
 * Remove special characters !@#$%^&*().,-
 * If the size is extra-small - take the first letter of it.
 * If there's 1 word - take the first letter of it.
 * If there are 2+ words - take the first letter of the first and second words.
*/
export var getAvatarInitials = (name, showSingleInitial) => {
  var [firstName, lastName] = name.replace(/[!@#$%^&*().,-]/g, '').split(' ');
  var firstNameLetter = firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0).toUpperCase();

  if (showSingleInitial) {
    return firstNameLetter;
  }

  return firstName && lastName ? "".concat(firstName.charAt(0).toUpperCase()).concat(lastName.charAt(0).toUpperCase()) : firstNameLetter;
}; // Re-exporting util to avoid import cycle error.

export var isBrandSymbol = _isBrandSymbol;
//# sourceMappingURL=avatar.utils.js.map